import React, {useState, useMemo, useEffect} from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import { useNavigate, useParams } from "react-router-dom";
  import axios from "axios";
  import { apiUrl } from "../../config/Config";

  import {
    faPlus,
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { useSelector, useDispatch } from "react-redux";
  import Editor from "../common/Editor";

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

const EditBlog = () => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const dispatch = useDispatch();
  const { id } = useParams();
    const [forceupdate, setforceupdate] = useState(false);
    const [editorLoaded, setEditorLoaded] = useState(true);

    const [title, settitle] = useState("");
    const [sdesc, setsdesc] = useState("");
    const [bimage, setbimage] = useState(null);
    const [bdesc, setbdesc] = useState("");

    const navigate = useNavigate();

    const handlesubmitcoupon = async() => {
      if(title && sdesc && bdesc) {
        var data = {
            id: id,
          title: title,
          sdesc: sdesc,
          image: bimage,
          desc: bdesc,
        }
        console.log('data >>', data);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "updateblog",data, headers)
          .then((res) => {
            // console.log('res >>', res.data)
            // category data
            if (res?.data?.status == "success") {
              navigate('/admin/blogs')
            } else {
              if (res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} });
                navigate("/admin/login");
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            console.log("err >>", err);
          });
  
        
      }
      
      // 
    }

    const getBase64 = (file) => {
      return new Promise((resolve) => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();
  
        // Convert the file to base64 text
        reader.readAsDataURL(file);
  
        // on reader load somthing...
        reader.onload = () => {
          // Make a fileInfo Object
          // console.log("Called", reader);
          baseURL = reader.result;
          // console.log(baseURL);
          resolve(baseURL);
        };
        // console.log(fileInfo);
      });
    };

    const handleinputchange = async (file) => {
      var obj = {};
      await getBase64(file).then((result) => {
        obj["name"] = file.name;
        obj["image"] = result;
      });
      // console.log('obj >>', obj);
      setbimage(obj);
    };

    const fetchproductdetails = async(id) => {
        const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
    
          var data = {
            id: id
          }
          let resp = await axios
            .post(apiUrl + "fetchblogdetails", data, headers)
            .then((res) => {
              // console.log('res >>', res.data)
              // category data
              if (res?.data?.status == "success") {
                //category data
               console.log('res data >>>', res?.data);
               var prevdata = res?.data?.data;
               settitle(prevdata?.title);
               setsdesc(prevdata?.sdesc);
               setbdesc(prevdata?.desc);
            //    setbimage(prevdata?.image);
               
              } else {
                if (res.data.message == "invalid user") {
                  dispatch({ type: "userdata", payload: {} });
                  navigate("/admin/login");
                } else {
                  alert(res.data.message);
                }
              }
            })
            .catch((err) => {
              console.log("err >>", err);
            });
      }

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
          fetchproductdetails(id);
        } else {
          navigate("/admin/login");
        }
      }, [id]);

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="inventorysave-row addproduct-save-row">
            <p className="inventorysummary-text addproduct-text">
              Edit Blog
            </p>
            {/* <div className="inventory-save-btn add-product-btn add-product-btn1" onClick={() => {handlesubmitcoupon(0)}}>
              <p>Save as draft</p>
            </div> */}
            <div className="inventory-save-btn add-product-btn" style={{marginLeft: 'auto'}} onClick={() => {handlesubmitcoupon(1)}}>
              <p>Update</p>
            </div>
          </div>
          <div className="inventorysummaryrow row mt-3">
            <div className="col-md-4">
              <div className="">
                <label className="addproduct-label">Title</label>
                <input
                value={title}
                onChange={(t) => {settitle(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter Title of Blog"
                />
              </div>
              <div className="mt-3">
              <label className="addproduct-label">Short Description</label>
                <textarea
                value={sdesc}
                onChange={(t) => {setsdesc(t.target.value)}}
                  className="form-control addproductinput"
                  style={{ height: 135 }}
                  placeholder="Enter Short Description"
                ></textarea>
              </div>
              <div className="mt-3">
                    <label className="addproduct-label">Blog Image</label>
                    <input
                    onChange={(t) => {
                      handleinputchange(t.target.files[0]);
                    }}
                      accept="image/*"
                      type="file"
                      className="form-control addproductinput"
                      placeholder="Blog Image"
                    />
                  </div>
              
            </div>
            <div className="col-md-8">
            <div className="">
              <label className="addproduct-label">Blog Details</label>
              <div className="descriptionckeditor" style={{ marginTop: 7 }}>
                <Editor
                  name="name"
                  value={bdesc}
                  onChange={(data) => {
                    setbdesc(data);
                  }}
                  editorLoaded={editorLoaded}
                  className="addproductinput"
                />
              </div>
            </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
    );
}

export default EditBlog;